import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  deactivateTeamMember,
  downloadTeamMembersCsv,
  inviteTeamMember,
  reactivateTeamMember,
  resendTeamInvitation,
  triggerCsvDownload,
} from './teamMembers.api'
import type { ListTeamMembersParams } from './teamMembers.types'

export function useTeamMemberMutations() {
  const queryClient = useQueryClient()

  const invalidateTeamList = () =>
    queryClient.invalidateQueries({ queryKey: ['team'] })

  const deactivate = useMutation({
    mutationFn: deactivateTeamMember,
    onSuccess: invalidateTeamList,
  })

  const reactivate = useMutation({
    mutationFn: reactivateTeamMember,
    onSuccess: invalidateTeamList,
  })

  const resendInvitation = useMutation({
    mutationFn: resendTeamInvitation,
    onSuccess: invalidateTeamList,
  })

  const invite = useMutation({
    mutationFn: inviteTeamMember,
    onSuccess: invalidateTeamList,
  })

  const exportCsv = useMutation({
    mutationFn: async (params: Omit<ListTeamMembersParams, 'page' | 'pageSize'>) => {
      const { blob, filename } = await downloadTeamMembersCsv(params)
      triggerCsvDownload(blob, filename)
    },
  })

  return { deactivate, reactivate, resendInvitation, invite, exportCsv }
}
